import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const Sup = ({ children, className }) =>
  <sup className={classNames('Sup', className)}>
    {children}
  </sup>;

Sup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

Sup.defaultProps = {
  className: null,
};

export default Sup;



// WEBPACK FOOTER //
// ./src/components/Sup/index.js